var $ = require('jquery')
  , _ = require('underscore')
  , urlUtils = require('@173js/url')
  , ued = window.ued || {}

var listUrlAndControllerMap = {
  game: '/game-list.html'
, 'shouyou/syGame': '/shouyou-list.html'
, 'vr/vrGame': '/vr-list.html?template=newgame'
}

var helperMixinAndControllerMap = {
  game: require('./mixins/newgameHelpers.js')
, 'shouyou/syGame': require('./mixins/shouyouHelpers.js')
, 'vr/vrGame': require('./mixins/vrHelpers')
}

var currentControllerId = ued.currentControllerId
  , helpersMixin = helperMixinAndControllerMap[currentControllerId]

function NavManager() {
  this.initialize()
  this.currentListUrl = listUrlAndControllerMap[currentControllerId]
}

NavManager.prototype.initialize = function() {
  if (this.getUrlParams) {
    this.urlParams = this.getUrlParams()
  } else {
    var params = urlUtils.getURLParameters(window.location.search)
    ;delete params.page;
    this.urlParams = params
  }
}

_.each(helpersMixin, function(method, methodName) {
  NavManager.prototype[methodName] = method
})

NavManager.prototype.getRenderNavHelpers = function() {
  //TODO: DRY
  _.bindAll(this, 'getNavClass', 'getFilterUrl')
  return _.pick(this, 'getNavClass', 'getFilterUrl')
}

module.exports = NavManager
